import * as sidecar from "@/lib/sidecar/config"

export const IS_TESTNET = sidecar.getValue("isTestnet")
